import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { clientServerBlog } from "../../index";

// Fetch all blogs
export const fetchAllBlogs = createAsyncThunk("blogs/fetchAll", async () => {
  const res = await clientServerBlog.get("/api/v1/blogs/list");

  return res.data;
});

// Fetch single blog by slug
export const fetchBlogById = createAsyncThunk(
  "blogs/fetchById",
  async (slug) => {
    const res = await clientServerBlog.get(`/api/v1/blogs/by-slug/${slug}`);
    return res.data;
  }
);

// Initial state with loading and error
const initialState = {
  list: [],
  detail: null,
  loading: false,
  error: null,
};

const blogsSlice = createSlice({
  name: "blogs",
  initialState,
  reducers: {
    clearBlogs: (state) => {
      state.list = [];
    },
    clearBlogDetail: (state) => {
      state.detail = null;
    },
    setSelectedTitle: (state, action) => {
      state.selectedTitle = action.payload;
    },
    clearSelectedTitle: (state) => {
      state.selectedTitle = null;
    },
  },
  extraReducers: (builder) => {
    builder

      // All blogs
      .addCase(fetchAllBlogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllBlogs.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.value;
      })
      .addCase(fetchAllBlogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Single blog
      .addCase(fetchBlogById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlogById.fulfilled, (state, action) => {
        state.loading = false;
        state.detail = action.payload.value;
      })
      .addCase(fetchBlogById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearBlogs, clearBlogDetail, setSelectedTitle, clearSelectedTitle } = blogsSlice.actions;
export default blogsSlice.reducer;
